
import { CircularProgress, createTheme, withStyles } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { BLUE, GREEN } from '../../_config/consts';
import OfficeModeIconCustom from '../CustomIcons/OfficeModeIconCustom.jsx';
import MDButton from '../MDButton/MDButton.jsx';

const styles = theme => ({
  container: {
    overflowY: 'auto',
    height: '120vh',
    paddingLeft: 15,
    paddingBottom: 220,
    paddingRight: 20,
    paddingTop: 80,
  },
  rowContainer: {
    padding: 20,
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    marginBottom: 15,
  },
  rowTitle: {
    fontWeight: 'bold',
    color: '#3f3f3f',
    margin: 0,
  },
  rowDescription: {
    color: '#3f3f3f',
    margin: 0,
    fontSize: 16,
  },
  rowBody: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 5,
  },
});

const theme = createTheme({
  palette: {
    primary: { 500: BLUE },
  },
});

const EmptyProfileView = ({ onCreateNew }) => (
  <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: 20, marginTop: 150, marginRight: 50 }}>
    <OfficeModeIconCustom style={{ color: '#bdbdbd', width: 50, alignSelf: 'center' }} />
    <h3 style={{ color: '#bdbdbd', fontWeight: 'bold', textAlign: 'center', marginTop: 0 }}><Entity entity="noTimeProfileFound" /></h3>
    <h4 style={{ color: '#bdbdbd', fontWeight: 'normal',lineHeight: '1.3em', textAlign: 'center', marginTop: 0 }}><Entity entity="noTimeProfileFoundDescription" /></h4>
    <MDButton
      title={<Entity entity="createTimeProfile" />}
      titleStyle={{ marginTop: 0, fontSize: 13 }}
      backgroundColor={GREEN}
      containerStyle={{ margin: 0, marginTop: 10 }}
      onClick={() => onCreateNew()}
    />
  </div>
);

const TimeProfileRow = ({ timeProfile, classes, onRowClick }) => (
  <Card className={`card card-rounded ${classes.rowContainer}`} style={{ cursor: 'pointer' }} onClick={() => onRowClick()}>
    <h4 style={{ fontWeight: 'bold' }}>{timeProfile.name}</h4>
  </Card>
);

class CompanyTimeProfilesListView extends React.Component {
  render() {
    const { timeProfilesData, onRowClick, onCreateNew, classes } = this.props;
    return (
      <div className={classes.container}>
        <InfiniteScroll
          initialLoad={false}
          loadMore={() => {}}
          hasMore={false}
          useWindow={false}
          loader={
            <div style={{ marginTop: 0, backgroundColor: 'white', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingVertical: 5, }}>
              <h4 style={{ textAlign: 'center', color: '#3f3f3f' }}><Entity entity="loadingLogs" /></h4>
              <CircularProgress className={classes.circularProgress} />
            </div>
          }
        >
          <div>
            {!_.isEmpty(timeProfilesData) ?
              _.map(timeProfilesData, (timeProfile) =>
                <TimeProfileRow
                  timeProfile={timeProfile}
                  key={timeProfile.id}
                  classes={classes}
                  onRowClick={() => onRowClick(timeProfile)}
                />)
                : (
                  <div>
                    <EmptyProfileView
                      onCreateNew={() => onCreateNew()}
                    />
                  </div>
                )
              }
          </div>
        </InfiniteScroll>
      </div>
    );
  }

}
export default withStyles(styles)(CompanyTimeProfilesListView);